<template>
    <el-button
            v-loading="loading"
            type="text"
            class="btn-send-sms"
            element-loading-spinner="el-icon-loading"
            element-loading-custom-class="buttonLoading"
            :disabled="isGetIng"
            @click="getCode"
    >
        {{ smsCodeText }}
    </el-button>
</template>

<script>
    import {sendByRegister,sendByCodeLogin,sendByFind,sendByPay} from '../../api/sms'
    export default {
        name: 'SendSms',
        props: {
            mobile: {
                type: [String, Number],
                default: null
            },
            mobileName: {
                type: String,
                default: 'mobile'
            },
            smsType:{
                type: String,
                default: 'code' // reg = 注册验证码，code = 登录或其他验证码，find = 找回密码验证码
            }
        },
        data() {
            return {
                smsCodeCountdown: -1,
                isGetIng: false,
                loading: false
            }
        },
        computed: {
            smsCodeText() {
                if (this.smsCodeCountdown === -1) {
                    return '发送验证码'
                } else if (this.smsCodeCountdown > 0) {
                    return '已发送(' + this.smsCodeCountdown + ')'
                } else {
                    return '重新发送'
                }
            }
        },
        /*async mounted(){
            const storeCountdown = await this.$store.dispatch('sms/getCountdown');
            this.smsCodeCountdown = storeCountdown;
            // console.log( storeCountdown , this.$store.state.sms.countdown )
            if( storeCountdown > 0 ) {
                this.startCountdown( storeCountdown )
                this.isGetIng = true
            }
        },*/
        methods: {
            startCountdown(times = 60) {
                this.smsCodeCountdown = times
                const countdown = setInterval(() => {
                    this.smsCodeCountdown--
                    if (this.smsCodeCountdown === 0) {
                        clearInterval(countdown)
                        this.resetBtn()
                    }
                }, 1000)
            },
            async getCode() {
                let regPhone=/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
                if(!regPhone.test(this.mobile)){
                    this.$alert('请输入正确的手机号', '提示');return false;
                }
                this.loading = true;
                if(this.smsType=='reg'){
                    await sendByRegister(this.mobile).then(()=>{
                        this.isGetIng = true
                        this.startCountdown()
                    }).catch(err=>{
                        console.log(err)
                    })
                }
                if(this.smsType=='code'){
                    await sendByCodeLogin(this.mobile).then(()=>{
                        this.isGetIng = true
                        this.startCountdown()
                    }).catch(err=>{
                        console.log(err)
                    })
                }
                if(this.smsType=='find'){
                    await sendByFind(this.mobile).then(()=>{
                        this.isGetIng = true
                        this.startCountdown()
                    }).catch(err=>{
                        console.log(err)
                    })
                }
                if(this.smsType=='pay'){
                    await sendByPay(this.mobile).then(()=>{
                        this.isGetIng = true
                        this.startCountdown()
                    }).catch(err=>{
                        console.log(err)
                    })
                }
                this.loading = false
            },
            resetBtn() {
                this.isGetIng = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .btn-send-sms{
        position: absolute;
        bottom:6px;
        right:0;
        color:#333333;
    }
    .el-button--text ,.el-button--text:hover{
        color: #333333;
    }
</style>